import Vertical from "./Vertical.template";

export default Vertical;
